import e from "./useMutationObserver.js";
import t from "./useEffectOnce.js";
import { THEME_DARK as n, THEME_DATA_ATTRIBUTE as r } from "../utils/colorScheme.js";
import { useCallback as i, useState as a } from "react";
//#region src/hooks/useDarkMode.ts
var o = () => {
	let [o, s] = a(!1);
	t(() => {
		document.documentElement.getAttribute("data-theme") === "dark" && s(!0);
	});
	let c = i((e) => {
		e.forEach((e) => {
			if (e.type === "attributes" && e.attributeName === "data-theme") {
				let t = e.target.getAttribute(r);
				s(t === n);
			}
		});
	}, []);
	return e(document.documentElement, c, {
		attributes: !0,
		childList: !1,
		subtree: !1
	}), o;
};
//#endregion
export { o as default };

//# sourceMappingURL=useDarkMode.js.map